// /admin/eval/viewer — real route. Mirrors apps/web's
// app/admin/eval/viewer/page.tsx: fully self-contained 'use client' page
// (upload/paste a saved eval JSON blob, or load a saved batch via
// GET /api/admin/eval/batches[/:slug], both already ported in
// apps/server/src/routes/admin-eval.ts), no route params (the `?slug=`
// query is read via next/navigation's useSearchParams shim), lazy-imported
// directly per the porting convention (route-helpers.tsx). Registered from
// routes/admin.tsx under the `_admin` guard (routes/guards.tsx).
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './guards';

const AdminEvalViewerPage = lazy(() => import('@/app/admin/eval/viewer/page'));

export const adminEvalViewerRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/admin/eval/viewer',
  component: AdminEvalViewerPage,
});
